import * as STD                                                 from '@emersya/mpa-std-lib';
import CM                                                       from '@emersya/mpa-components-manager-lib';

export interface IInputJSONComponentConfiguration extends IInputFormComponentConfiguration {
};

export class InputJSONComponent extends InputFormComponent<
	InputJSONComponent,
	IInputJSONComponentConfiguration
>
{
	private onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		void ev;
	};

	override deserialize(x : boolean) {
		return (x);
	};

	override isValueTheDefault() {
		return (false);
	};

	override async reset() {
		await super.reset();
		// await this.updateValue(this.configuration.defaultValue || null);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IInputJSONComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.addEventListener('value', this.onValueUpdated.bind(this), {
			subType :  InputJSONComponent.type,
			listener : this
		});
	};
};
export namespace NS {
	export const Component = InputJSONComponent;
	export type Component = InputJSONComponent;
	export type Configuration = IInputJSONComponentConfiguration;
}
;
// import './InputBool.scss';
import { InputFormComponent, IInputFormComponentConfiguration } from '../InputForm/InputForm';

CM.declare({
	id :   'input-JSON',
	type : InputJSONComponent
});
